@if ({ modalStatus: vtoBeautyFacade.modalStatus$ | async, cameraDimension: vtoBeautyFacade.cameraDimension$ | async };
as vto) {
<div
    class="vto-module-camera"
    [style.height.px]="vto.cameraDimension?.height"
    [style.width.px]="vto.cameraDimension?.width">
    @if (vto.modalStatus === 'CAMERA_LOADING') {
    <div class="vto-module-spinner"></div>
    }
    <!-- Displayed only if no error - prevent A11Y focus issues  -->
    @if (vto.modalStatus !== 'ON_ERROR') {
    <div
        class="vto-module-iframe"
        id="YMK-module"
        #ymkModule
        [class.on-air]="vto.modalStatus === 'CAMERA_LOADED'"
        data-cs-mask></div>
    }
</div>
}
